import { userInfoSync } from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
const getIsUngated = gateName => {
  const {
    gates
  } = userInfoSync();
  return gates.includes(gateName);
};
const getHasScope = scope => {
  const {
    user
  } = userInfoSync();
  return user.scopes.includes(scope);
};
export const isMultiBrandEnabled = () => {
  return getIsUngated(gate('BuyerExperience:SalesDocumentsMultiBrand')) && getHasScope('business-units-access');
};